module.exports = __webpack_public_path__ + "img/DSC_2266_referencia_thumb.69b7f8e8.jpg";